

import { Time } from '@angular/common';
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import * as TimeSpan from 'timespan';
import { PatientRegistration } from './patient-registration';
import { Department, DepartmentData } from '../masters/department';
import { Physician } from '../masters/physician-mst';
import { Visit } from '../ehr/visit';

export interface PatientAppointmentParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface PatientAppointment {
  cancelReason?: any;
  patientGender?: any;
  patientName?: any;
  patientAge?: any;
  patientMobileNo?: any;
    id?: any;
    tenantId: any;
    branchId: any;
    appointmentId?: any;
    doctorId: any;
    regId: any;
  appointmentMode?:number;

    cancellationDate: Date;
    bookingstatusId: any;
    actualStartTime: any;
    actualEndTime: any;
    bookingChannelId: any;
    type: string;
    departmentId: any;
    date: Date;
    slotTime: any;
    duration: number;
    patientRegistration?: PatientRegistration;
    department?: Department;
    doctor?: Physician; 
    templateId?:string;
    parameters?: PatientAppointmentParameter[];
    links?: any;
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
    amount?:any; //Doctor configure charges amount save field added by Raja 28-12-2021
    //new columns added by Raja 10-02-2022
     PatientName?:string;
     PatientAge?:string;
     PatientGender?:string;
     PatientMobileNo?:string;
     RoomNo?:string;
     TokenNumber?:string;
     DoctorTokenNumber?:number;
     HospitalTokenNumber?:number;
     resetFromDate?: Date;
     resetToDate?: Date;
     whenApptCharges?:string;
     appointmentEndDate?:any;
     queueStatus?:string;
     appointmentType?:number;
     districtId?:string;
     flag?
     departmentName?:string;
     doctorTitle?:string;
     doctorName?:string;
     isunregisterPatientConverted?:boolean;
     patientRegNum?:string;
     dobFlag?:string;
     ageResult?:string;
     patientDOB?:string;
     timeSlot?:string;
     appointmentConfirmationflag?:boolean;
     PatientTitle?:number;
     PatientBirthAge?:number;
     PatientAddress1?:string;
     PatientAddress2?:string;
     patientCity?:string;
     patientPincode?:string;
     RegisterStatus?:string;
     Reason?:string;
     CheckInRequired?:string;
     CheckOutRequired?:string;
     patientBirthMonth?:number;
     patientBirthDay?:number;
     registrationServiceId?:string;
     autoPostRegistrationChargesFlag?:string;
     registrationCharge?:string;
     serviceType?:number;
     isValdiateDuplicate?:boolean;
     district?:string;
     country?:string;
     state?:string;
     aaadhar?:string,
     cityAreaId?:string,
     isActive?:boolean,
     referralType?:string;
     referralId?: string;
      othersReferralName?:string;
      othersReferralAddress?:string;
      othersReferralMobile?: string;
      remarks?: string;
      communicationType?:string;
}

export class Event {
    id: string;
    start_date: Date;
    end_date: Date;
    slot: number;
    leave: boolean
  }
  
export abstract class PatientAppointmentData {
    abstract patAptData$: Observable<PatientAppointment[]>;
    abstract getById(url: string): Observable<any>;
    abstract list(url: string): Observable<PatientAppointment[]>;
    abstract create(url: string, data: PatientAppointment): Observable<PatientAppointment>;
    abstract bulkUpdate(url: string, data: PatientAppointment): Observable<PatientAppointment>;
    abstract update(url: string, data: PatientAppointment): Observable<PatientAppointment[]>;
    abstract cancelApt(url: string, data:any): Observable<any>;
    abstract delete(url: string): Observable<any>;
    abstract changePatAptList(data: PatientAppointment[]):void;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract createAppointment(url: string, data: PatientAppointment): Observable<any>;
    abstract getPatientBookedPastAppts(url: string): Observable<any>;
    abstract getSlots(url: string): Observable<any>;
    abstract createApptVisit(url: string, data: PatientAppointment): Observable<Visit>;
    abstract patch(url: string, data): Observable<any>;

}